export default __webpack_public_path__ + "static/media/close-modal.53b51220.svg";